"use client";
import { useState } from "react";
import { ErrorMessage } from "@components/primitives/ErrorMessage";
import { useFeatureFlag } from "@lib/feature-flags/FeatureFlagsContext";
import { EditableProfilePersonalDetails } from "./EditableProfilePersonalDetails";
import { EditableProfileEmail } from "./EditableProfileEmail";
import { EditableProfileDeleteAccount } from "./EditableProfileDeleteAccount";
import { EditableProfilePassword } from "./editable-profile-password/EditableProfilePassword";
import { AccountDeactivationSection } from "./AccountDeactivationSection";

interface Props {
    data: any;
}

export const ProfileList = ({ data }: Props) => {
    const [errorMessage, setErrorMessage] = useState("");
    const hasAccountDeactivation = useFeatureFlag("hasAccountDeactivation");

    return (
        <>
            {errorMessage && <ErrorMessage message={errorMessage} />}
            <EditableProfilePersonalDetails
                personalDetails={data}
                globalErrorHandler={setErrorMessage}
            />
            <EditableProfileEmail email={data.email} emailLabel={data.emailLabel} />
            <EditableProfilePassword />
            {hasAccountDeactivation ? (
                <AccountDeactivationSection />
            ) : (
                <EditableProfileDeleteAccount />
            )}
        </>
    );
};

export default ProfileList;
